import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UtilsModule } from '@vsolv/ui-kit/utils';
import { SignInButtonComponent } from './components';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, UtilsModule],
  declarations: [SignInButtonComponent],
  exports: [SignInButtonComponent],
  // providers: [AuthService],
})
export class AuthWebModule {
  static forRoot() {
    return {
      ngModule: AuthWebModule,
    };
  }
}
